<!-- =========================================================================================
  File Name: ClientEditTabSettings.vue
  Description: Client Edit Tab Settings page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<style lang="scss">
.con-img-upload {
  background: #efeeee;
}
.custom-domain-wrap {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.input-wdt {
  width: 70%;
  margin-right: 15px;
}
.button-wrap {
  text-align: right;
}
.auth-check {
  width: 100%;
  display: flex !important;
  justify-content: space-between !important;
  align-items: center !important;
}

/*------ menu icons-----*/
.menu-delete .icon {
  width: 25px;
  height: 25px;
  cursor: pointer;
}
.menu-delete img {
  width: 25px;
  height: 25px;
  cursor: pointer;
}
.single-list {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.menu-editwrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.editbox-menu {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
}
.con-vs-avatar {
  background: transparent !important;
  width: 40px;
  height: 40px;
}
.vs-avatar--con-img {
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.vs-avatar--con-img img {
  height: auto !important;
  width: 63% !important;
}
.manage-menu-wrap-hld ul.wizard-nav.wizard-nav-pills {
  display: none;
}
.manage-menu-wrap-hld .wizard-progress-with-circle {
  display: none;
}
.header-custome {
  margin-bottom: 15px;
}
.knowlg-base-wrap-sec a {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 12px;
}
.knowlg-base-wrap-sec a span {
  margin-right: 10px;
  line-height: 0;
}
/*------------06-07-2020------------*/
.type-evnt {
  display: flex !important;
  justify-content: space-between !important;
  align-items: center !important;
  width: 100% !important;
  margin-top: 23px;
}
label.type-evnt-lbl {
  width: 110px;
  margin-right: 10px;
}
.allmenu-topicons {
  display: inline-block;
}
.menu-dragbox .vs-list--item {
  background: #ddd;
  margin-bottom: 10px;
  border-radius: 5px;
}
.menu-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.type-evnt {
  width: 250px !important;
  margin-top: 0;
}
.NotificationShow {
  display: flex;
  justify-content: flex-end;
}
.menu-dragbox {
  height: 340px;
  overflow-y: scroll;
}
.manage-menu-wrap-hld .wizard-header {
  display: none;
}
.manage-menu-wrap-hld .wizard-tab-content {
  padding-top: 0 !important;
}
.manage-menu-wrap-hld .wizard-tab-container {
    background: #fff;
    padding: 15px;
    border-radius: 10px;
    box-shadow: 0 0 8px rgba(0,0,0,0.2);
}
.manage-menu-wrap-hld .wizard-tab-content {
    width: 100% !important;
}
.mail-tmplt-btns {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.mail-tmplt-btns a {
  position: relative;
  font-weight: 500;
  font-size: 14px;
  color: #4c8af6;
  cursor: pointer;
  border: 1px solid #4c8af6;
  display: inline-block;
  padding: 4px 12px;
}
.off-after {
  border-radius: 0 4px 4px 0;
  border-left: none !important;
}
.right-off-radius {
  border-radius: 4px;
}
.mail-tmplt-btns label {
  font-size: 16px;
  font-weight: 16px;
}
</style>
<template>
  <div id="client-edit-tab-settings" v-if="PostLoginOptionsLoaded">
    <h3 class="my-5">Post Login Options</h3>
    <div class="vx-row mb-6">
      <div class="vx-col md:w-1/2 w-full mt-4">
          <label class="mr-5 mt-2">Default Login Landing Page</label>
          <v-select
            class="w-full select-large"
            v-model="PostLoginOptions.DefaultLoginLandingPage"
            :options="landingURLOptions"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-validate="'required'"
            name="DefaultLoginLandingPage"
          />
          <span class="text-danger text-sm" v-show="errors.has('DefaultLoginLandingPage')">This field is required</span>
      </div>

      <div class="vx-col md:w-1/2 w-full mt-4">
        <label class="mr-5 mt-2">Whats App Number</label>
        <vs-input
          class="w-full"
          v-model="PostLoginOptions.WhatsAppNumber"
        />
      </div>

      <div class="vx-col md:w-3/12 w-full mt-4">
        <label class="mr-5 mt-2">Custom Font Name</label>
        <vs-input
          class="w-full"
          v-model="customClientFont.FontFamily"
        />
      </div>

      <div class="vx-col md:w-3/12 w-full mt-4">
        <label class="mr-5 mt-2">Custom Font Format</label>
        <vs-input
          class="w-full"
          v-model="customClientFont.FontFormat"
        />
      </div>

      <div class="vx-col md:w-6/12 mt-4">
        <label class="mr-5 mt-2">Custom Font Path</label>
        <div class="flex flex-wrap items-center">
          <vs-input
            class="md:w-7/12"
            v-model="customClientFont.FontPath"
          />
          <vs-input class="ml-1 md:w-4/12" type="file" v-model="CustomFontPath" @change="uploadCustomFont" />
        </div>
      </div>

      <div class="vx-col md:w-1/1 w-full mt-4">
          <label class="mr-5 mt-2">Client Lobby HTML</label>
          <div class="mail-tmplt-btns">
            <div class="tmplt-btn-wrap">
              <a
                class="right-off-radius"
                @click="showRawHtml = showRawHtml ? false : true"
                >{{ showRawHtml ? "Editor" : "HTML Code" }}</a
              >
            </div>
          </div>
          <ckeditor class="desc-event" v-if="!showRawHtml" v-model="PostLoginOptions.ClientLobbyHTML" :config="editorConfig"></ckeditor>
          <vs-textarea
            v-if="showRawHtml"
            v-model="PostLoginOptions.ClientLobbyHTML"
            class="inputx w-full"
            rows="10"
            cols="100"
          />
      </div>
    </div>
    <div class="sub-menu-head">
      <h5>Set Client Level Menu Options:</h5>
    </div>
    <div class="vx-row">
          <input type="file" class="hidden" ref="changeIcon" @change="UpdateIcon" accept="image/*" />
          <div class="vx-col sm:w-1/3 w-full mt-4">
            <vs-list>
              <div class="vx-col sm:w-1/1 w-full mb-1">
                <div class="menu-head">
                  <vs-list-header title="Available Menus" color="primary"></vs-list-header>
                  <span class="allmenu-topicons">                    
                  </span>
                </div>
              </div>

               <draggable 
                :list="AvailableMenu"
                :move="checkMoveSelected"
                :group="{name:'tags',pull: 'clone', put: false }"
                class="p-2 cursor-move menu-dragbox"
              >
                <vs-list-item
                  v-for="(listItem, index) in AvailableMenu"
                  :key="index"
                  :title="listItem.DisplayLabel"
                >
                  <vs-avatar :src="listItem.IconUrl" slot="avatar" :text="listItem.DisplayLabel" />
                </vs-list-item>
              </draggable>

            </vs-list>
          </div>
          <div class="vx-col sm:w-1/3 w-full mt-4">
            <vs-list>
              <div class="menu-head">
                <vs-list-header title="Top / App Bottom Menu" color="primary"></vs-list-header>
                <vx-tooltip text="Delete all menus" position="top">
                  <span class="menu-delete ml-4" @click="removeAll('top')">
                    <feather-icon icon="TrashIcon" />
                  </span>
                </vx-tooltip>
              </div>

              <draggable
                :list="SelectedMenu"
                :group="{name: 'tags'}"
                class="p-2 cursor-move menu-dragbox"
              >
                <vs-list-item
                  class="single-list"
                  v-for="(listItem, index) in SelectedMenu"
                  :key="index"
                  :title="listItem.DisplayLabel"
                >
                  <vs-avatar
                    :src="listItem.IconUrl"
                    slot="avatar"
                    :text="listItem.DisplayLabel"
                    @click="hideTextBox(listItem.MenuID)"
                  />
                  <div class="menu-editwrap">
                    <div class="editbox-menu">
                      <vs-input
                        :placeholder="listItem.DisplayLabel"
                        :class="listItem.MenuID==TextBoxShowingId ? 'show' : 'hidden'"
                        v-model="listItem.DisplayLabel"
                      />
                    </div>
                    <span class="menu-delete ml-4" @click="showTextBox(listItem.MenuID)">
                      <img src="../../assets/images/icon-edit.png" />
                    </span>
                    <span class="menu-delete ml-4">
                      <feather-icon
                        class="icon"
                        icon="UploadIcon"
                        @click="UploadIcon('top',listItem.MenuID)"
                      />
                    </span>
                    <span class="menu-delete ml-4" @click="removeSelected(listItem.MenuID)">
                      <img src="../../assets/images/delete.svg" />
                    </span>
                  </div>
                </vs-list-item>
              </draggable>

            </vs-list>
          </div>

          <div class="vx-col sm:w-1/3 w-full mt-4">
            <vs-list>
              <div class="menu-head">
                <vs-list-header title="Left / App Hamburger Menu" color="primary"></vs-list-header>
                <vx-tooltip text="Delete all menus" position="top">
                  <span class="menu-delete ml-4" @click="removeAll('left')">
                    <feather-icon icon="TrashIcon" />
                  </span>
                </vx-tooltip>
              </div>

              <draggable 
                :list="SelectedLeftMenu"
                :group="{name: 'tags'}"
                class="p-2 cursor-move menu-dragbox"
              >
                <vs-list-item
                  class="single-list"
                  v-for="(listItem, index) in SelectedLeftMenu"
                  :key="index"
                  :title="listItem.DisplayLabel"
                >
                  <vs-avatar
                    :src="listItem.IconUrl"
                    slot="avatar"
                    :text="listItem.DisplayLabel"
                    @click="hideTextBox(listItem.MenuID)"
                  />
                  <div class="menu-editwrap">
                    <div class="editbox-menu">
                      <vs-input
                        :placeholder="listItem.Name"
                        :class="listItem.MenuID==TextBoxShowingId ? 'show' : 'hidden'"
                        v-model="listItem.DisplayLabel"
                      />
                    </div>
                    <span class="menu-delete ml-4" @click="showTextBox(listItem.MenuID)">
                      <img src="../../assets/images/icon-edit.png" />
                    </span>
                    <span class="menu-delete ml-4">
                      <feather-icon
                        class="icon"
                        icon="UploadIcon"
                        @click="UploadIcon('left',listItem.MenuID)"
                      />
                    </span>
                    <span class="menu-delete ml-4" @click="removeSelectedLeft(listItem.MenuID)">
                      <img src="../../assets/images/delete.svg" />
                    </span>
                  </div>
                </vs-list-item>
              </draggable>

            </vs-list>
          </div>
        </div>

    <div class="vx-row">
      <div class="vx-col md:w-1-12 w-full mt-5 button-wrap">
        <vs-button class="mb-2" @click="before_save">Save</vs-button>
      </div>
    </div>
  </div>
</template>
<script>
import vSelect from "vue-select";
import draggable from "vuedraggable";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import CKEditor from 'ckeditor4-vue';
import CKconfig from "@/assets/ckeditor-config.ts";

var vm;
export default {
  components: {
    flatPickr,
    vSelect,
    draggable,
    ckeditor: CKEditor.component
  },
  /*props: {
    data: {
      type: Object,
      required: true,
    }, 
  },*/
  data() {
    return {
      editorConfig: CKconfig.editorConfig,
      //PostLoginOptions: JSON.parse(JSON.stringify(this.data)),
      showRawHtml: false,
      favicon: null,
      ClientId: this.$route.params.clientId,
      PostLoginOptionsLoaded: false,
      CustomFontPath: null,
      customClientFont: {
        FontFamily: "",
        FontFormat: "",
        FontPath: ""
      },
      PostLoginOptions: {
        DefaultLoginLandingPage: '/eventBased',
        WhatsAppNumber: '',
        customClientFont: {
          FontFamily: "",
          FontFormat: "",
          FontPath: ""
        },
        ClientLobbyHTML: ""
      },
      landingURLOptions: [        
        "/eventBased",
        "/clientLobby"      
      ],
      AvailableMenu: [],
      SelectedMenu: [],
      SelectedLeftMenu: [],
      TextBoxShowingId: -1,
      updateIconMenuId: 0,
      updateMenuList: null,
    };
  },

  methods: {
    before_save() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll().then((result) => {
          //resolve(result);
          if (result) {
            resolve(vm.save_changes());
          }
        });
      });
    },
    save_changes() {
      // Here will go your API call for updating data
      // You can get data in "this.data_local"
      this.$vs.loading();
      /* eslint-enable */
      const Id = this.$route.params.clientId;
      if (Id) {
        this.PostLoginOptions.AdditionalMenu = this.SelectedMenu
        this.PostLoginOptions.LeftMenu = this.SelectedLeftMenu
        this.PostLoginOptions.customClientFont = this.customClientFont
        this.$store
          .dispatch("clientManagement/updateClientPostLoginOption", {
            id: Id,
            PostLoginOptions: this.PostLoginOptions
          })
          .then((res) => {
            this.$vs.notify({
              color: "success",
              title: "Client",
              text: res.message,
            });
            this.$vs.loading.close();
          })
          .catch((err) => {
            this.$vs.loading.close();
          });
      }
    },
    uploadCustomFont(input){
      if (input.target.files && input.target.files[0]) {
        const file = input.target.files[0];
        const metadata = {
          contentType: file.type,
        };
        this.$vs.loading();
        let path = `OA_UAT/${this.ClientId}/`
        this.$store.dispatch("clientManagement/uploadFile", { file: file, path: path }).then((res) => {
          this.$vs.loading.close();
          vm.customClientFont.FontPath = res;
        })
      }
    },
    UploadIcon(menuListName, menuId) {
      this.$refs.changeIcon.click();
      this.updateMenuList = menuListName;
      this.updateIconMenuId = menuId;
    },
    UpdateIcon(input) {
      if (input.target.files && input.target.files[0]) {
        const file = input.target.files[0];
        const metadata = {
          contentType: file.type,
        };
        const validImageTypes = ["image/gif", "image/jpeg", "image/png"];
        if (!validImageTypes.includes(file.type)) {
          alert("Only gif,jpeg & png file allowed.");
          return false;
        }
        let fileWH = '50x50';
        let dimension = fileWH.split("x");
        var _URL = window.URL || window.webkitURL;
        let img = new Image();
        var objectUrl = _URL.createObjectURL(file);
        
        img.onload = function () {
          if (this.width <= dimension[0] && this.height <= dimension[1]) {
            const reader = new FileReader();
            reader.onload = (e) => {
              vm.processUpload(file)
            };
            reader.readAsDataURL(input.target.files[0]);
          } else {
            alert("File dimension does not match " + fileWH);
            return false;
          }
          _URL.revokeObjectURL(objectUrl);
        };
        img.src = objectUrl;

        
      }
    },
    processUpload(file){
      let MenuID = this.updateIconMenuId;
        let menuListName = this.updateMenuList;

        this.updateMenuList = null;
        this.updateIconMenuId = 0;

        this.$vs.loading();
        return new Promise((resolve, reject) => {
          this.$store
            .dispatch("clientManagement/updateMenuIcon", { file: file, clientId: this.ClientId })
            .then((res) => {
              let menulink = res;
              this.$vs.notify({
                color: "success",
                position: "top-center",
                title: "Menu",
                text: "Menu Icon Updated",
              });

              if (menuListName == "top") {
                this.SelectedMenu = this.SelectedMenu.map((menu) => {
                  if (menu.MenuID === MenuID) {
                    return { ...menu, IconUrl: menulink };
                  }
                  return { ...menu };
                });
              } else if (menuListName == "left") {
                this.SelectedLeftMenu = this.SelectedLeftMenu.map((menu) => {
                  if (menu.MenuID === MenuID) {
                    return { ...menu, IconUrl: menulink };
                  }
                  return { ...menu };
                });
              }

              this.$vs.loading.close();
            }).catch(err=>{ this.$vs.loading.close(); });
        });
    },
    checkMoveSelected: function (evt) {
      //console.log(evt.draggedContext.element.MenuID)
      //console.log(evt.relatedContext.element.MenuID)
      let MenuID = evt.draggedContext.element.MenuID;
      let found = this.SelectedMenu.some((el) => el.MenuID === MenuID);
      let foundl = this.SelectedLeftMenu.some((el) => el.MenuID === MenuID);
      if (found || foundl) return false;
      else return true;
    },
    showTextBox(id) {
      this.TextBoxShowingId = id;
    },
    hideTextBox(id) {
      this.TextBoxShowingId = -1;
    },
    removeAll(menuListName) {
      if (
        confirm(
          "Are you sure want to clear all " +
            menuListName.toUpperCase() +
            " menu"
        )
      ) {
        if (menuListName == "top") {
          this.SelectedMenu = [];
        } else if (menuListName == "left") {
          this.SelectedLeftMenu = [];
        }
      }
    },
    removeSelected(id) {
      var index = this.SelectedMenu.map((x) => {
        return x.MenuID;
      }).indexOf(id);

      this.SelectedMenu.splice(index, 1);
    },
    removeSelectedLeft(id) {
      var index = this.SelectedLeftMenu.map((x) => {
        return x.MenuID;
      }).indexOf(id);

      this.SelectedLeftMenu.splice(index, 1);
    },
  },
  mounted(){
    
  },
  created() {
    vm = this;
    this.$vs.loading();
    this.$store
        .dispatch("clientManagement/fetchPostLoginOptions", this.ClientId)
        .then(res => { 
          this.$vs.loading.close();
          this.PostLoginOptionsLoaded = true;
          if(res.PostLoginOptions)
          {            
            this.PostLoginOptions = res.PostLoginOptions;
            this.SelectedMenu = res.PostLoginOptions.AdditionalMenu ? res.PostLoginOptions.AdditionalMenu : [];
            this.SelectedLeftMenu = res.PostLoginOptions.LeftMenu ? res.PostLoginOptions.LeftMenu : [];
            this.PostLoginOptions.WhatsAppNumber = res.PostLoginOptions.WhatsAppNumber ? res.PostLoginOptions.WhatsAppNumber : "";
            this.PostLoginOptions.customClientFont = res.PostLoginOptions.customClientFont ? res.PostLoginOptions.customClientFont : {FontFamily:"", FontFormat: "",  FontPath:""};
            this.customClientFont = res.PostLoginOptions.customClientFont ? res.PostLoginOptions.customClientFont : {FontFamily:"", FontFormat: "",  FontPath:""};
          }          
              
      }).catch((err) => {
            this.$vs.loading.close();
          });
    this.$store.dispatch("clientManagement/fetchAllMenu", this.ClientId).then(res => {             
      this.AvailableMenu = res;              
    })
     
  },
};
</script>